var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNameHover = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23.902,
    viewBox: "0 0 20 23.902",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.55,12.28a5.64,5.64,0,1,1,5.64-5.64A5.64,5.64,0,0,1,15.55,12.28Zm0-9.428c-2.092,0-4.093,2.612-3.788,2.788.071-.026,7.522-.021,7.576,0A4.4,4.4,0,0,0,15.55,2.852Z",
    transform: "translate(25.55 12.28) rotate(180)",
    fill: "#959cf2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.928,26.9H19.172a4.233,4.233,0,0,0,4.378-4.054c0-4.33-3.791-7.84-8.466-7.849H12.016c-4.675.008-8.461,3.519-8.466,7.849A4.233,4.233,0,0,0,7.928,26.9Zm7.157-10.415a6.628,6.628,0,0,1,6.859,6.361,2.683,2.683,0,0,1-2.771,2.567H7.928a2.683,2.683,0,0,1-2.771-2.567,6.628,6.628,0,0,1,6.859-6.361Z",
    transform: "translate(-3.55 -3.001)",
    fill: "#3953fb"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNameHover, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/nameHover.322f17f8.svg";
export { ForwardRef as ReactComponent };